import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Box,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Chip,
  Collapse,
} from "@mui/material";
import {
  Edit as EditIcon,
  Check as CheckIcon,
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import { formatCurrency } from "../../utils/formatters";
import CategoryRatesSection from "./CategoryRatesSection";

const TrainerRow = ({
  trainer,
  isMobile,
  availableCategories,
  onUpdateTrainerCost,
  onOpenAddCategoryDialog,
  onUpdateCategoryRate,
  onDeleteCategoryRate,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");

  const handleStartEdit = () => {
    setIsEditing(true);
    setEditValue(trainer.hourly_cost?.toString() || "");
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditValue("");
  };

  const handleSaveEdit = async () => {
    const success = await onUpdateTrainerCost(trainer.id, editValue);
    if (success) {
      setIsEditing(false);
      setEditValue("");
    }
  };

  return (
    <React.Fragment>
      {/* Main trainer row */}
      <TableRow hover>
        <TableCell>
          <IconButton size="small" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {trainer.full_name}
            </Typography>
            {trainer.category_rates?.length > 0 && (
              <Chip
                size="small"
                label={`${trainer.category_rates.length} kat.`}
                color="primary"
                variant="outlined"
              />
            )}
          </Box>
          {isMobile && (
            <Typography variant="caption" color="text.secondary">
              {trainer.email}
            </Typography>
          )}
        </TableCell>
        {!isMobile && (
          <TableCell>
            <Typography variant="body2" color="text.secondary">
              {trainer.email}
            </Typography>
          </TableCell>
        )}
        <TableCell align="right">
          {isEditing ? (
            <TextField
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              type="number"
              size="small"
              sx={{ width: 120 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">PLN</InputAdornment>
                ),
              }}
              autoFocus
            />
          ) : (
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: trainer.hourly_cost ? "success.main" : "warning.main",
              }}
            >
              {trainer.hourly_cost !== null
                ? formatCurrency(trainer.hourly_cost)
                : "Nie ustawiono"}
            </Typography>
          )}
        </TableCell>
        <TableCell align="center">
          {isEditing ? (
            <Box
              sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}
            >
              <IconButton
                size="small"
                color="success"
                onClick={handleSaveEdit}
              >
                <CheckIcon />
              </IconButton>
              <IconButton
                size="small"
                color="error"
                onClick={handleCancelEdit}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          ) : (
            <IconButton size="small" onClick={handleStartEdit}>
              <EditIcon />
            </IconButton>
          )}
        </TableCell>
      </TableRow>

      {/* Expanded category rates section */}
      <TableRow>
        <TableCell
          colSpan={isMobile ? 4 : 5}
          sx={{ py: 0, borderBottom: isExpanded ? 1 : 0 }}
        >
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <CategoryRatesSection
              trainer={trainer}
              availableCategories={availableCategories}
              onOpenAddDialog={onOpenAddCategoryDialog}
              onUpdateCategoryRate={onUpdateCategoryRate}
              onDeleteCategoryRate={onDeleteCategoryRate}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default TrainerRow;
